import React, { memo, useEffect, useMemo } from 'react'
import { Select } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { employeeSelector, getEmployeesAction } from '../../../store/employeе'

const EmployeeSelector = ({ value, onChange, mode = null, roles, ...rest }) => {
  const dispatch = useDispatch()
  const { employees } = useSelector(employeeSelector)

  useEffect(() => {
    if (!employees || employees.length === 0) {
      dispatch(getEmployeesAction({ fields: ['id', 'first_name', 'second_name'] }))
    }
  }, [dispatch])

  let options = useMemo(
    () => employees?.map(({ id, first_name, second_name }) => ({ value: id, label: `${first_name} ${second_name}` })),
    [employees]
  )

  return (
    <Select
      value={value}
      onChange={onChange}
      options={options}
      mode={mode}
      allowClear
      dropdownMatchSelectWidth={false}
      {...rest}
    />
  )
}

export default memo(EmployeeSelector)
